(() => {
  const root = window.Shopify?.routes?.root || '/';
  const updateCount = (count) => {
    document.querySelectorAll('[data-santo-cart-count]').forEach((badge) => {
      badge.textContent = count;
      badge.hidden = count < 1;
    });
  };
  const refreshCount = async () => {
    const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
    if (response.ok) updateCount((await response.json()).item_count);
  };
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-card-qty-minus],[data-card-qty-plus]');
    if (!button) return;
    const input = button.closest('.santo-card-quantity')?.querySelector('input');
    if (!input) return;
    input.value = Math.max(1, Number(input.value || 1) + (button.hasAttribute('data-card-qty-plus') ? 1 : -1));
  });
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('.santo-ajax-form');
    if (!form) return;
    if (event.submitter && !event.submitter.matches('.santo-add,.santo-product-submit')) return;
    event.preventDefault();
    const button = form.querySelector('[type="submit"]');
    const original = button?.textContent;
    if (button) { button.disabled = true; button.textContent = 'Adding…'; }
    try {
      const response = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      if (!response.ok) throw new Error('Unable to add this item');
      await refreshCount();
      if (button) button.textContent = 'Added ✓';
      form.dispatchEvent(new CustomEvent('santo:item-added', { bubbles: true }));
    } catch (error) {
      if (button) button.textContent = 'Try again';
    } finally {
      setTimeout(() => { if (button) { button.disabled = false; button.textContent = original; } }, 1400);
    }
  });
  refreshCount().catch(() => {});
})();
